import { toastr } from "../_components/toastr/toastr";
import { accountService } from "../_services/accounts.service";

export function handleResponse(response: Response) {
    return response.text().then(text => {
        let data;

        try {
            data = text && JSON.parse(text);
        } catch (e) {
            data = text;
        }

        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                accountService.logout();
                // window.location.reload(true);
            }

            return Promise.reject(data);
        }
        return data;
    });
}


export function handleErrorResponse(err: any) {
    toastr.error(err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}

export function handleErrorResponseAxios(err: any) {

    toastr.error((err && err.response ? err.response.data : null) || err.Message || err.message || err.title || err || "Something went wrong. Please try again later");
}